// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-64dd1478]{display:-webkit-box;display:-ms-flexbox;display:flex;color:#273142;padding:10px;border-radius:6px;font-size:14px;border:1px solid transparent;-webkit-box-align:center;-ms-flex-align:center;align-items:center}p img[data-v-64dd1478]{margin-right:10px}p .link[data-v-64dd1478]{color:#f27a1a;border-bottom:1px solid #f27a1a}p.warning[data-v-64dd1478]{border-color:#f27a1a;background-color:#fdf1e8}p.danger[data-v-64dd1478]{border-color:#ff5043;background-color:#ffedec}", ""]);
// Exports
module.exports = exports;
